import React, { useState } from 'react';
import {
  Button,
  FormControl,
  FormHelperText,
  InputLabel,
  OutlinedInput,
  TextField,
} from '@mui/material';
import styles from './AddressForm.module.css';
import { ChoosePaymentMethodElementInterface } from './ChoosePaymentMethodElement';

export const AddressForm = ({
  choosePaymentMethodElement,
  ...props
}: {
  chosenPlan: JSX.Element;
  paymentOption: JSX.Element;
  choosePaymentMethodElement: ChoosePaymentMethodElementInterface;
}) => {
  const [address, setAddress] = useState({
    country: '',
    area: '',
    district: '',
    line1: '',
    line2: '',
  });
  return (
    <div className={styles.addressFormContainer}>
      <span className={styles.title}>Shipping Details</span>
      <div className={styles.infoWrapper}>
        {props.chosenPlan}
        {props.paymentOption}
      </div>
      <div className={styles.form}>
        <TextField
          sx={{ width: 'inherit' }}
          fullWidth
          color="primary"
          variant="outlined"
          type="text"
          label="Country"
          size="medium"
          margin="none"
          onChange={(event) => {
            setAddress((prev) => {
              return { ...prev, country: event.target.value };
            });
          }}
        />
        <TextField
          sx={{ width: 'inherit' }}
          fullWidth
          color="primary"
          variant="outlined"
          type="text"
          label="Area"
          size="medium"
          margin="none"
          onChange={(event) => {
            setAddress((prev) => {
              return { ...prev, area: event.target.value };
            });
          }}
        />
        <TextField
          sx={{ width: 'inherit' }}
          fullWidth
          color="primary"
          variant="outlined"
          type="text"
          label="District"
          size="medium"
          margin="none"
          onChange={(event) => {
            setAddress((prev) => {
              return { ...prev, district: event.target.value };
            });
          }}
        />
        <TextField
          sx={{ width: 'inherit' }}
          fullWidth
          color="primary"
          variant="outlined"
          type="text"
          label="Address Line 1"
          size="medium"
          margin="none"
          onChange={(event) => {
            setAddress((prev) => {
              return { ...prev, line1: event.target.value };
            });
          }}
        />
        <TextField
          sx={{ width: 'inherit' }}
          fullWidth
          color="primary"
          variant="outlined"
          type="text"
          label="Address Line 2"
          size="medium"
          margin="none"
          onChange={(event) => {
            setAddress((prev) => {
              return { ...prev, line2: event.target.value };
            });
          }}
        />
      </div>
      <div className={styles.buttonContainer}>
        <Button
          variant="contained"
          sx={{ width: '100%' }}
          onClick={() => {
            choosePaymentMethodElement.bnpl(address);
          }}
        >
          Continue
        </Button>
        <Button
          variant="text"
          sx={{ width: '100%' }}
          onClick={choosePaymentMethodElement.closeAddressForm}
        >
          Back
        </Button>
      </div>
    </div>
  );
};
